import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Links = ({ links, classes, onClick, onNewTab = false }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);

  return (
    <ul className={classes || "flex gap-2 flex-col "}>
      {links.map((link, index) => {
        const additionalProps =
          isLoggedIn && link.url2 === "/sign-up"
            ? { state: { redirectToStep: 6 } }
            : {};
        return (
          <li key={index} className="hover:text-slate footer_link">
            {isLoggedIn && link.url2 === "/sign-up" ?
              <Link
                to={onNewTab ? null : isLoggedIn ? link.url2 : link.url}
                {...additionalProps}
                onClick={()=>onClick(link)}
              >
                {link.text}
              </Link> : <Link 
                to={onNewTab ? null : isLoggedIn ? link.url2 : link.url}
                {...additionalProps}
                onClick={()=>onClick(link)}
              >
                {link.text}
              </Link>}
          </li>
        );
      })}
    </ul>
  );
};

export default Links;
